import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'
import Map from 'components/Map'
import { ExternalLink } from 'react-feather'

const ModalInsuranceMap = ({ isOpen, toggle, data }) => {
  const lat = data?.latitude ? parseFloat(data.latitude) : null
  const lng = data?.longitude ? parseFloat(data.longitude) : null
  const isValidCoords =
    lat !== null && lng !== null && !isNaN(lat) && !isNaN(lng)

  const center = isValidCoords
    ? { lat, lng }
    : { lat: -6.2088, lng: 106.8456 }

  const mapData = isValidCoords
    ? [
        {
          landName: data?.alamat_lokasi_lahan || 'Lokasi Lahan',
          plottingPoint: {
            coordinates: [lng, lat],
          },
          locationPoint: {
            coordinates: [lng, lat],
          },
        },
      ]
    : []

  return (
    <Modal
      centered
      size="lg"
      isOpen={isOpen}
      toggle={toggle}
      data-testid="farmer-insurance-map-modal"
    >
      <ModalHeader toggle={toggle}>Lokasi Lahan</ModalHeader>
      <ModalBody>
        <div className="mb-3">
          <div className="row g-2">
            <div className="col-12">
              <span className="fw-semibold">Alamat Lokasi Lahan</span>
              <p className="text-muted mb-0">
                {data?.alamat_lokasi_lahan || '-'}
              </p>
            </div>
            <div className="col-md-6">
              <span className="fw-semibold">Wilayah</span>
              <p className="text-muted mb-0">
                {[data?.desa, data?.kecamatan, data?.kabupaten, data?.provinsi]
                  .filter(Boolean)
                  .join(', ') || '-'}
              </p>
            </div>
            <div className="col-md-6">
              <span className="fw-semibold">Koordinat</span>
              <p className="text-muted mb-0 font-monospace">
                {isValidCoords ? `${lat}, ${lng}` : '-'}
              </p>
            </div>
          </div>
        </div>

        <div
          className="rounded overflow-hidden border position-relative"
          style={{
            height: '55vh',
            width: '100%',
            minHeight: '360px',
            backgroundColor: '#f8f9fa',
          }}
        >
          {isValidCoords ? (
            <Map data={mapData} center={center} />
          ) : (
            <div className="d-flex justify-content-center align-items-center h-100">
              <span className="text-muted">Koordinat lokasi tidak valid</span>
            </div>
          )}
        </div>
      </ModalBody>
      <ModalFooter className="d-flex justify-content-between align-items-center">
        {isValidCoords ? (
          <a
            href={`https://www.google.com/maps?q=${lat},${lng}`}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-outline-primary btn-sm d-inline-flex align-items-center gap-1"
          >
            <ExternalLink size={14} /> Buka di Google Maps
          </a>
        ) : (
          <div />
        )}
        <Button color="secondary" size="sm" onClick={toggle}>
          Tutup
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default ModalInsuranceMap
